/* TOURANCE — CINEMATIC LAYER (cinematic.js) rev4
   Site-wide: scroll-reveal, sticky CTA, scroll-progress everywhere;
   hero parallax + dramatic tagging homepage-only. No-JS safe.

   rev4: the homepage collection-tiles ink repaint is now OPT-IN.
   It only applies when the section is actually set to "Ink" in the
   theme editor (body section has .section--ink). Otherwise the
   section keeps whatever background the editor specifies. */
(function () {
  "use strict";
  var body = document.body;
  var isHome = body.classList.contains("template-index");
  var isCart = body.classList.contains("template-cart");
  var prefersReduced = window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function tagSections() {
    var main = document.getElementById("MainContent") || body;
    Array.prototype.forEach.call(main.children, function (node) {
      node.classList.add("cine-reveal");
    });
    [".tile-grid", ".curated-best__grid", ".product-grid",
     ".curated-collections__grid", ".collection-grid", ".looks-grid"].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (g) { g.classList.add("cine-stagger"); });
    });
    document.querySelectorAll(".curated-best, .trust, .section--ink, .image-banner").forEach(function (el) {
      el.classList.add("cine-edge");
    });
    if (isHome) {
      var tileGrid = document.querySelector(".tile-grid");
      if (tileGrid) {
        var tilesSection = tileGrid.closest(".section");
        if (tilesSection) {
          tilesSection.classList.add("cine-edge");
          /* Only repaint the tiles as the ink gallery when the editor
             actually set this section to Ink. Respects the bg setting. */
          if (tilesSection.classList.contains("section--ink")) {
            tilesSection.classList.add("cine-tiles");
          }
        }
      }
      var editorials = document.querySelectorAll(".editorial");
      editorials.forEach(function (ed, i) {
        var sec = ed.closest(".section");
        if (!sec) return;
        if (i === 0) sec.classList.add("cine-editorial-dark");
        sec.classList.add("cine-edge");
      });
      var hero = document.querySelector(".sh2");
      if (hero) hero.classList.add("cine-reveal");
    }
  }

  function setupReveal() {
    var targets = document.querySelectorAll(".cine-reveal, .cine-stagger, .cine-edge");
    if (!("IntersectionObserver" in window) || prefersReduced) {
      targets.forEach(function (t) { t.classList.add("is-revealed"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -8% 0px" });
    targets.forEach(function (t) { io.observe(t); });
    setTimeout(function () { targets.forEach(function (t) { t.classList.add("is-revealed"); }); }, 3500);
  }

  function setupParallax() {
    if (prefersReduced || !isHome) return;
    var layers = document.querySelectorAll(".sh2__media");
    if (!layers.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.pageYOffset;
        if (y < 1100) {
          var shift = y * 0.12;
          layers.forEach(function (el) { el.style.transform = "translate3d(0," + shift + "px,0)"; });
        }
        ticking = false;
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function setupStickyCta() {
    if (isCart) return;
    var bar = document.createElement("div");
    bar.className = "cine-sticky";
    bar.innerHTML =
      '<a href="/collections/new-arrivals-auto">' +
        '<span class="cine-sticky__dot"></span>' +
        '<span>Ships today · <strong>order by 3 PM PT</strong></span>' +
      '</a>';
    body.appendChild(bar);
    var footer = document.querySelector("footer, .footer, #shopify-section-footer-group") ||
      document.querySelector('[class*="footer"]');
    function update() {
      var scrolled = window.pageYOffset;
      var showAfter = window.innerHeight * 0.6;
      var nearBottom = false;
      if (footer) {
        var fTop = footer.getBoundingClientRect().top;
        nearBottom = fTop < window.innerHeight + 80;
      }
      if (scrolled > showAfter && !nearBottom) { bar.classList.add("is-visible"); }
      else { bar.classList.remove("is-visible"); }
    }
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function setupProgress() {
    var bar = document.createElement("div");
    bar.className = "cine-progress";
    body.appendChild(bar);
    var ticking = false;
    function update() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var pct = h > 0 ? (window.pageYOffset / h) * 100 : 0;
        bar.style.width = pct + "%";
        ticking = false;
      });
    }
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  function init() {
    tagSections();
    setupReveal();
    setupParallax();
    setupStickyCta();
    setupProgress();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
